import Image from 'next/image'
import pluralize from 'pluralize'

import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Row from '@ilg-totallymoney/ui/components/Row'
import Text from '@ilg-totallymoney/ui/components/Text'
import Icon from '@ilg-totallymoney/ui/icons/Icon'
import theme from '@ilg-totallymoney/ui/theme'

import totallySureLogo from '@images/TotallySure-logo.png'

import { StyledButton } from './TotallySureTooltipBanner.styled'

const TotallySureTooltipBanner = ({
    numberOfTotallySureCardOffers,
    onClick,
}: {
    numberOfTotallySureCardOffers?: number
    onClick: () => void
}) => {
    if (!numberOfTotallySureCardOffers) {
        return null
    }

    return (
        <StyledButton
            aria-label="Opens a modal that explains what TotallySure offers means"
            onClick={onClick}
        >
            <Row
                space="space10"
                backgroundColor="eligibilityLevel2-30"
                py="space05"
                pl="space10"
                pr="space15"
                borderRadius="borderRadius20"
                alignItems="center"
                justifyContent={[
                    'space-between',
                    'space-between',
                    'flex-start',
                ]}
            >
                <Row space="space10" alignItems="center">
                    <Flex alignItems="center">
                        <Image
                            alt="TotallySure logo"
                            src={totallySureLogo}
                            width={90}
                            height={40}
                        />
                    </Flex>

                    <Text variant="80" color="light" textAlign="left">
                        <strong>
                            You have {numberOfTotallySureCardOffers} TotallySure{' '}
                            {pluralize(
                                'offer',
                                numberOfTotallySureCardOffers,
                                false
                            )}
                        </strong>{' '}
                        <Box as="span" display={['none', 'none', 'inline']}>
                            with pre-approval and guarantees (subject to final
                            checks)
                        </Box>
                    </Text>
                </Row>

                <Icon icon="tooltip" size={20} color={theme.grey100} />
            </Row>
        </StyledButton>
    )
}

export default TotallySureTooltipBanner
